import { type AnyAction } from 'redux';
import { SHOW_HEADER_LOGIN } from './show-header-login';

type State = { showLogin: boolean };

const initialState: State = {
  showLogin: true,
};

export default function headerWidget(state: State = initialState, action: AnyAction): State {
  switch (action.type) {
    case SHOW_HEADER_LOGIN:
      return {
        showLogin: action.payload,
      };
    default:
      return state;
  }
}
